import { createStore, applyMiddleware, compose } from 'redux';
import createPromise from 'redux-promise-middleware';
import rootReducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

export const createReduxStore = (initialState) => {
    const middleware = [thunk];
    const enhancers = [];
    let store = {};

    middleware.push(createPromise());
    enhancers.push(applyMiddleware(...middleware));

    if (window.location.hostname.toUpperCase() === 'LOCALHOST')
    {
        window.NODE_ENV = 'development';
        store = createStore(rootReducer, initialState, composeWithDevTools(...enhancers));
    }
    else
    {
        window.NODE_ENV = 'production';
        store = createStore(rootReducer, initialState, compose(...enhancers));
    }

    return store;
};
